import { Instrument } from 'src/app/shared/state/instruments/instrument.model';
import { PortfolioTemplate } from '../types/portfolio-template.interface';
import { uuidv4 } from 'src/app/shared/utils/utils';
import { DEFAULT_REPORT_CONTENT_CONFIG } from '../components/sb-template-create/consts';

export const DEFAULT_PORTFOLIO_TEMPLATE: PortfolioTemplate = {
    id: uuidv4(),
    title: 'Default',
    description:
        'The default portfolio template. This template represents a clean slate from which other templates can be created.',
    accountFilterConfig: {
        excludedLegalEntities: [],
        excludedIssuers: [],
        excludedAccounts: []
    },
    instrumentFilterConfig: {
        excludedTypes: [],
        excludedIds: []
    },
    benchmarks: [],
    allocationView: 'all',
    allocationDimension: 'assetClass',
    allocationTrail: null,
    activeDimensions: [],
    allocationChartType: 'bar',
    chartView: 'performance',
    contentConfig: DEFAULT_REPORT_CONTENT_CONFIG
};

export const AVAILABLE_INSTRUMENT_TYPES: Array<Instrument['type']> = [
    'BOND',
    'CONVERTIBLE',
    'FUND',
    'ETF',
    'LOAN',
    'DEPOSIT',
    'FUTURE',
    'GENERIC',
    'COMPANY',
    'CRYPTO',
    'INVESTMENT_FIRM',
    'FXSPOT',
    'FXFORWARD',
    'OPTION',
    'PRIVATE_EQUITY',
    'PE_PREF_SHARE',
    'PE_OTHER_SHARE',
    'PE_CONVERTIBLE',
    'PE_OPTION',
    'PE_INVESTMENT_FIRM',
    'PE_LOAN',
    'PE_SHAREHOLDER_CONTRIBUTION',
    'EQUITY',
    'SUBSCRIPTIONRIGHT',
    'PRIVATE_ASSET',
    'COMMERCIAL_REAL_ESTATE'
];
